import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "systemd",
  "use": "systemd-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"systemd\"><path d=\"M2 6v3.628h1.395V9.07h-.837V6.558h.837V6zm10.605 0v.558h.837V9.07h-.837v.558H14V6zM8.28 7.814l2.511-1.396V9.21zM6.187 9.07a1.256 1.256 0 1 0 0-2.512 1.256 1.256 0 0 0 0 2.512\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol